/* template */
<template minapp="mpx" xlang="wxml"><div class="es-card"><div class="es-card__title"><div class="es-card__title-left"><div>{{fromStationName}}</div><es-icon name="arrow-switch-right" color="#666666" size="20"/><div>{{toStationName}}</div></div><div class="es-card__title-price" v-if="(price)"><div class="es-card__rich-text small">¥</div><div class="es-card__rich-text large">{{ price}}</div></div></div><div v-for="(item, idx) in (cardInfos)" class="es-card__title"><div class="es-card__item es-card__item-text">{{item.title}} : {{item.value}}</div><div class="es-card__item-detail" v-if="(idx === (cardInfos.length-1))">查看详情<es-icon color="#666666" size="12" name="angle-right"></es-icon></div></div></div></template>

/* styles */
<style scoped lang="stylus" src="./style.styl" mpxStyleOptions='{"mid":"m8b3e9d62"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m8b3e9d62"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex8b3e9d62%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex8b3e9d62%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m8b3e9d62"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index8b3e9d62/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
